import React from 'react';

import Hero from 'components/hero';
import BenefitArticle from 'components/benefit-article';

import Image1 from 'svg/illustrations/undraw_press_play_bx2d.svg';

const EmployerMyLearning = () => {
  return (
    <Hero layout="vertical">
      <BenefitArticle
        title="MyLearning is an online platform provided free to all MyShifts Workers"
        image={Image1}
      >
        <p>
          It gives them access to all the Mandatory E Learning they need to help
          you comply with your organisation’s registration with the regulatory
          bodies. It manages workers learning and development needs and allows
          them to access their learning whenever they like, on any device they
          like.
        </p>
        <p>
          This means that they can continue to learn and develop their knowledge
          irrespective of where they work.
        </p>
        <p>
          This in turn means employers can have peace of mind knowing the
          workers they employ are keeping up to date with their learning and
          development needs as well as new updates and learning.
        </p>
        <p>
          This also saves you, the employer, the expense of providing the
          Mandatory Training to comply with Registration and associated
          regulations.
        </p>
        <p>
          Workers can also upload their previous learning including more
          in-depth face to face training and the associated
          certificates/qualifications.
        </p>
        <p>
          Ultimately this will enable workers to share their learning history
          including certificates with you when you ‘connect’ with them. This
          will help you decide which worker is best suited to the shift you are
          looking fill.
        </p>
      </BenefitArticle>
    </Hero>
  );
};

export default EmployerMyLearning;
